import request from '@/utils/request'


// banner
export function getBanner(params) {
    return request({
        url: '/api/index',
        method: 'get',
        params,
    })
}

// 获取分类

export function getCategory(params) {
    return request({
        url: '/api/category',
        method: 'get',
        params,
    })
}


